import React from "react";
import styled from "styled-components";
import { FontSize, FontWeight, content } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { Platform } from "@linkfluence/models/platform";
import { tr } from "@radarly/i18n";
import { Post, PostLensFactory } from "@radarly/models/posts";

interface IProps {
  post: Post;
  locale: Locale;
  className?: string;
  onClick?: () => void;
}

const Name = styled.span`
  font-weight: ${FontWeight.Bold};
  color: ${content};
  font-size: ${FontSize.Medium};
`;

const getAuthorNameOrAnonymous = (
  authorName: string,
  platform: Platform,
  locale: Locale
) => {
  if (platform === Platform.Twitter && !authorName) {
    return tr(locale, "SOCIAL::INSTAGRAM::ANONYMOUS");
  }
  if (platform === Platform.Facebook && !authorName) {
    return tr(locale, "SOCIAL::FACEBOOK::ANONYMOUS");
  }
  return authorName;
};

const RadarlyPostAuthorName = ({
  post,
  locale,
  className,
  onClick,
}: IProps) => {
  const lens = PostLensFactory.create(post);

  return (
    <Name className={className} onClick={onClick}>
      {getAuthorNameOrAnonymous(
        lens.getPlatform() === "review"
          ? lens.getAuthorName()
          : lens.getPostAuthorName(),
        lens.getPlatform(),
        locale
      )}
    </Name>
  );
};

export default RadarlyPostAuthorName;
